import { api } from '~/api.ts';
import { Tag, TagCategory } from '~/types/domain.ts';
import { TagResponse } from '~/types/platform.ts';

export async function getTags(ids?: number[]): Promise<Map<number, string>> {
    return api<TagResponse[]>(`/tags/get`, { method: 'POST', body: ids }).then((tags) => {
        const tagsById = new Map<number, string>();
        for (const tag of tags) {
            tagsById.set(tag.id, tag.name);
        }
        return tagsById;
    });
}

export function mergeTags(dst: number, src: number[]) {
    return api<void>('/tags/merge', { method: 'POST', body: { dst, src } });
}

export function createTag(name: string, category: TagCategory) {
    return api<Tag>('/tags', { method: 'POST', body: { name, category } });
}

export function searchTags(input: string, category: TagCategory) {
    return api<TagResponse[]>(`/tags/search/${category}`, {
        method: 'POST',
        body: { input },
    });
}
